document.addEventListener("DOMContentLoaded", (event) => {
    const readMoreButton = document.querySelector('.shopify-section--featured-collection .js-read-more-content');
    const contentElement = document.querySelector('.shopify-section--featured-collection .content');

    if (readMoreButton && contentElement) {
        // Check if content exceeds approx. 5 lines
        const computedStyles = window.getComputedStyle(contentElement);
        const lineHeight = parseFloat(computedStyles.lineHeight);
        const maxLines = 5;
        const maxHeight = lineHeight * maxLines;

        // Hide "Read More" button if content is short
        if (contentElement.scrollHeight <= maxHeight) {
            readMoreButton.style.display = 'none';
        }

        // Add expand-on-click functionality
        readMoreButton.addEventListener("click", (e) => {
            contentElement.classList.add('content-active');
            readMoreButton.classList.add('read-more-content--hide');
        });
    }
});
